// extracted by mini-css-extract-plugin
export default {"root":"_2mpmx","content":"_3Ovaw","rootHome":"_2pf6H","logo":"_1UgXJ"};